export const API = {
  GET_MESSAGES: {
    path: '/timeline-items/session/:id',
    method: 'GET',
  },
};

export const SENDER_TYPES = {
  USER: 'User',
  ASSISTANT: 'Assistant',
};

export const EVENT_SOURCE_RESPONSE_TYPES = {
  STRING: 'STRING',
  OBJECT: 'OBJECT',
  ERROR: 'ERROR',
};

export const SESSION_TYPES = {
  CHAT: 'chat',
  CALL: 'call',
};
